export const GatewayConfig = {
  default: 'capg', // capg, rz_native
  dealsGateway: 'rz_native', // capg, rz_native, default
}